// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".push-message-list-left-rim{border-left:3px solid #2196f3!important;border-bottom:5px solid #2196f3!important}.heading-row-gap,.text-row-gap{line-height:18px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
